"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const usersLicence_1 = __importDefault(require("../api/usersLicence"));
const AuthProvider_1 = require("./AuthProvider");
const react_2 = require("@fluentui/react");
const react_components_1 = require("@fluentui/react-components");
const react_router_dom_1 = require("react-router-dom");
const pl_PL_1 = require("../common/i18n/pl_PL");
const react_3 = require("@fluentui/react"); // Import Checkbox component
const EditLicence = () => {
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const [allowedServices, setAllowedServices] = (0, react_1.useState)([]);
    const [expirationTime, setExpirationTime] = (0, react_1.useState)();
    const [groupName, setGroupName] = (0, react_1.useState)();
    const [groupId, setGroupId] = (0, react_1.useState)();
    const [isDateSet, setIsDateSet] = (0, react_1.useState)(false);
    const [comment, setComment] = (0, react_1.useState)("");
    const { user } = (0, AuthProvider_1.useAuth)();
    const { userId } = (0, react_router_dom_1.useParams)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    (0, react_1.useEffect)(() => {
        userId && usersLicence_1.default.getUserGroup(user.access_token, userId).then((res) => {
            if (res.status == 404) {
                navigate(`/users`);
            }
            res.json()
                .then(body => {
                setGroupName(body[0].name);
                setGroupId(body[0].id);
                setIsLoading(false);
            });
        })
            .catch(err => {
            console.log(err);
        });
    }, []);
    function handleSubmit(event) {
        event.preventDefault();
        let createLicence = {
            iamGroups: [
                {
                    groupName: groupName,
                    groupId: groupId
                }
            ],
            allowedServices: allowedServices,
            expirationTime: expirationTime,
            comment: comment,
            beginingDate: new Date().getTime(),
            renewalDate: new Date().getTime()
        };
        userId && usersLicence_1.default.createLicence(user.access_token, userId, createLicence)
            .then(() => {
            navigate(`/users?groupName=${groupName}`);
        })
            .catch(error => {
            console.error('Error updating licence:', error);
            alert('Failed to update licence. Please try again.');
        });
    }
    function handleCheckboxChange(event, isChecked) {
        const { id } = (event === null || event === void 0 ? void 0 : event.currentTarget) || {};
        setAllowedServices((prev) => {
            const updatedServices = isChecked
                ? [...prev, { serviceId: id }]
                : prev.filter((s) => (s.serviceId !== id || s.feature));
            return updatedServices;
        });
    }
    function handleFeatureCheckboxChange(event, isChecked) {
        const { id } = (event === null || event === void 0 ? void 0 : event.currentTarget) || {};
        const [serviceId, feature] = id.split(":");
        setAllowedServices((prev) => {
            const updatedServices = isChecked
                ? [...prev, { serviceId, feature }]
                : prev.filter((s) => !(s.serviceId === serviceId && s.feature === feature));
            return updatedServices;
        });
    }
    function handleTextCommentChange(event, newValue) {
        setComment(newValue !== null && newValue !== void 0 ? newValue : "");
    }
    if (isLoading) {
        return react_1.default.createElement(react_components_1.Spinner, null);
    }
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement("form", { onSubmit: handleSubmit },
            react_1.default.createElement(react_2.Stack, { horizontal: true, tokens: { childrenGap: 15 } },
                react_1.default.createElement(react_2.Stack, { tokens: { childrenGap: 10 } },
                    react_1.default.createElement(react_3.Checkbox, { id: 'krs-add-in-app-v1', label: "WORD", name: "app", onChange: handleCheckboxChange }),
                    react_1.default.createElement("span", { style: { paddingLeft: "10px" } },
                        react_1.default.createElement(react_3.Checkbox, { id: 'krs-add-in-app-v1:download_pdf', label: "DOWNLOAD FEAT", name: "feature", onChange: handleFeatureCheckboxChange }))),
                react_1.default.createElement(react_2.Stack, { tokens: { childrenGap: 10 } },
                    react_1.default.createElement(react_3.Checkbox, { id: 'krs-calc-add-in-app-v1', label: "EXCEL", name: "app", onChange: handleCheckboxChange }),
                    react_1.default.createElement("span", { style: { paddingLeft: "10px" } },
                        react_1.default.createElement(react_3.Checkbox, { id: 'krs-calc-add-in-app-v1:download_pdf', label: "DOWNLOAD FEAT", name: "feature", onChange: handleFeatureCheckboxChange })))),
            react_1.default.createElement(react_2.DatePicker, { label: "Expiration Date", value: expirationTime ? new Date(expirationTime) : undefined, formatDate: (date) => date ? date.toLocaleDateString() : '', strings: pl_PL_1.i18nDatePicker, onSelectDate: (date) => {
                    if (date) {
                        setExpirationTime(Date.parse(date.toString()));
                        setIsDateSet(true);
                    }
                }, isRequired: true }),
            react_1.default.createElement(react_2.TextField, { style: { paddingBlock: "10px", height: "200px" }, multiline: true, resizable: true, onChange: handleTextCommentChange, value: comment, label: 'Komentarz' }),
            react_1.default.createElement(react_2.Stack, { horizontal: true, tokens: { childrenGap: 15, padding: "20px 10px 10px 10px" } },
                react_1.default.createElement(react_components_1.Button, { appearance: "primary", type: "submit", disabled: !isDateSet }, "Submit"),
                react_1.default.createElement(react_router_dom_1.Link, { to: `/users?groupName=${groupName}` },
                    react_1.default.createElement(react_components_1.Button, null, "Cancel"))))));
};
exports.default = EditLicence;
